export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallets"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar pallet"])},
          "pallets_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generar packing list"])},
          "download_format": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar formato"])},
          "upload_packing_list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subir packing list"])}
        }
      }
    }
  })
}